// src/components/Payment/PaymentSuccess.js
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../axiosConfig';

const PaymentSuccess = () => {
    const navigate = useNavigate();
    const token = new URLSearchParams(window.location.search).get('token');

    useEffect(() => {
        const executePayment = async () => {
            try {
                const response = await axiosInstance.post('/api/paypal/execute', { token });
                
                if (response.data.status === 'COMPLETED') {
                    navigate('/'); // Redirect to home or another page
                } else {
                   // console.error('Payment not completed');
                }
            } catch (error) {
               // console.error('Error executing payment:', error);
            }
        };

        if (token) executePayment();
    }, [navigate, token]);

    return <div>Processing payment...</div>;
};

export default PaymentSuccess;
